import React from 'react';
import Icon from '../app/common/components/Icon';
import { LoadingPage } from '../app/common/components/LoadingPage';
import ICONS from '../app/common/constants/icons';
import { IClientConfig, IPresentationConfig } from '../config/clientConfig';
import { TranslationHelpers } from '../i18n/translationHelpers';
import { IRoute } from '../routes/routes';
import {
    AvailablePoints,
    Base,
    BaseTile,
    BaseWrapper,
    IconWrapper,
    Left,
    MyDataLink,
    NoPointsTileBase,
    NoPointsTileLink,
    noPointsTileStyle,
    NoPointsWrapper,
    PendingPoints,
    PointsLine,
    PointsLink,
    PointsTile,
    pointsTileStyle,
    Right,
    rightBaseTileStyles,
    RouterBaseWrapper,
    TileLink,
    TilePointsText,
    TilePointsTitle,
    TileText,
    TileTitle,
    NoPointsTileWrapper,
    noPointsTileWrapperStyle,
    BuTilesWrapper,
    BuHeading,
    BuContainer,
    BuLeft,
    HomeTile,
    leftBuTileStyles,
    BuTileLink,
    BuLogoImage,
    rakutenFranceLogoStyles,
    BuTileText,
    rakutenFranceStyles,
    ArrowIcon,
    BuRight,
    BuSiteLinks,
    rightBuTileStyles,
} from './tilesStyle';
import { services } from './BuContent';
import { RegionHelper } from '../utils/RegionHelper';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { addRatEvent } from '../utils/ratClickEvents';
import { TopPageNotificationBanner } from './TopPageNotificationBanner';

interface ITilesDesktop {
    currentLanguage: string;
    routes: IRoute[];
    user: any;
    presentationConfig: IPresentationConfig;
    clientConfig: IClientConfig;
    loading: boolean;
    targetUrl: string;
    hasEKYC: boolean;
    hasSocialLink: boolean;
    buContent: Record<string, any>;
}

class TilesDesktop extends React.Component<ITilesDesktop & InjectedIntlProps> {
    constructor(props: ITilesDesktop & InjectedIntlProps) {
        super(props);
    }

    public render() {
        const {
            loading,
            targetUrl,
            user,
            routes,
            presentationConfig: {
                showSections: { points: showPoints, mydata },
            },
            intl,
            hasEKYC,
            hasSocialLink,
            buContent,
        } = this.props;
        const routesMap = routes.filter(
            (route) =>
                route.id !== 'points' &&
                (route.id !== 'ekyc' || hasEKYC) &&
                (route.id !== 'linked.accounts' || hasSocialLink),
        );
        const renderRoutes = routes.filter(
            (route) =>
                route.id !== 'cancel.membership' &&
                (route.id !== 'ekyc' || hasEKYC) &&
                (route.id !== 'linked.accounts' || hasSocialLink),
        );
        const newTabAriaLabel = intl.formatMessage(
            TranslationHelpers.getMessageDescriptor('newTab.ariaLabel'),
        );

        // get services images
        const buImages: string[] = [];
        let buContentIndexes: number[] = [];
        buContent.forEach((element: Record<string, any>, index: number) => {
            buContentIndexes.push(index);
            buImages.push(element?.image?.desktop);
        });

        if (loading) {
            return <LoadingPage />;
        }
        return (
            <Base>
                <BaseWrapper>
                    {!RegionHelper.isEU() && <TopPageNotificationBanner />}
                    <RouterBaseWrapper>
                        {showPoints ? (
                            <>
                                <Left>
                                    <PointsTile localStyles={pointsTileStyle}>
                                        <PointsLink to="/points-club">
                                            <IconWrapper>
                                                <Icon
                                                    icon={ICONS.POINTS_CLUB}
                                                    fill="#ffffff"
                                                    size={'40'}
                                                    viewBoxMax={'29'}
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                />
                                                <Icon
                                                    icon={ICONS.ARROW_RIGHT}
                                                    fill="#ffffff"
                                                    size={'16'}
                                                />
                                            </IconWrapper>
                                            <TilePointsTitle>
                                                {TranslationHelpers.getFormattedMessage(
                                                    'profile.points_club',
                                                )}
                                            </TilePointsTitle>
                                            <TilePointsText>
                                                {TranslationHelpers.getFormattedMessage(
                                                    'profile.points_check',
                                                )}
                                            </TilePointsText>
                                            <PointsLine></PointsLine>
                                            <AvailablePoints>
                                                {TranslationHelpers.getFormattedMessage(
                                                    'points.available.balance',
                                                )}
                                                <span>
                                                    {user.superPointsBalance
                                                        ? user.superPointsBalance
                                                        : 0}
                                                </span>
                                            </AvailablePoints>
                                            <PendingPoints>
                                                {TranslationHelpers.getFormattedMessage(
                                                    'points.pending.balance',
                                                )}
                                            </PendingPoints>
                                        </PointsLink>
                                    </PointsTile>
                                </Left>
                                <Right>
                                    {routesMap.map((route, index) => (
                                        <BaseTile
                                            localStyles={rightBaseTileStyles}
                                            key={route.path}
                                        >
                                            <TileLink className={`tst-tl${index}`} to={route.path}>
                                                <IconWrapper>
                                                    <Icon
                                                        icon={route.icon}
                                                        fill="#7F7F7F"
                                                        size={'40'}
                                                        viewBoxMax={'29'}
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                    />
                                                    <Icon
                                                        icon={ICONS.ARROW_RIGHT}
                                                        fill="#9c9c9c"
                                                        size={'16'}
                                                    />
                                                </IconWrapper>
                                                <TileTitle>
                                                    {TranslationHelpers.getFormattedMessage(
                                                        route.name.id,
                                                    )}
                                                </TileTitle>
                                                <TileText>
                                                    {TranslationHelpers.getFormattedMessage(
                                                        route.text.id,
                                                    )}
                                                </TileText>
                                            </TileLink>
                                        </BaseTile>
                                    ))}
                                </Right>
                            </>
                        ) : (
                            <NoPointsWrapper>
                                {renderRoutes.map((route, index) => (
                                    <NoPointsTileBase
                                        localStyles={noPointsTileStyle}
                                        key={route.path}
                                    >
                                        <NoPointsTileLink
                                            className={`tst-tl${index}`}
                                            to={route.path}
                                        >
                                            <IconWrapper>
                                                <Icon
                                                    icon={route.icon}
                                                    fill="#7F7F7F"
                                                    size={'40'}
                                                    viewBoxMax={'29'}
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                />
                                                <Icon
                                                    icon={ICONS.ARROW_RIGHT}
                                                    fill="#9c9c9c"
                                                    size={'16'}
                                                />
                                            </IconWrapper>
                                            <TileTitle>
                                                {TranslationHelpers.getFormattedMessage(
                                                    route.name.id,
                                                )}
                                            </TileTitle>
                                            <TileText>
                                                {TranslationHelpers.getFormattedMessage(
                                                    route.text.id,
                                                )}
                                            </TileText>
                                        </NoPointsTileLink>
                                    </NoPointsTileBase>
                                ))}
                                {mydata && (
                                    <NoPointsTileWrapper localStyles={noPointsTileWrapperStyle}>
                                        <MyDataLink
                                            onClick={() => {
                                                addRatEvent('mydata', 'mydata_link');
                                            }}
                                            className={`tst-tl5`}
                                            href={targetUrl}
                                            target={'_blank'}
                                        >
                                            <IconWrapper>
                                                <Icon
                                                    icon={ICONS.MY_DATA}
                                                    fill="#7F7F7F"
                                                    size={'40'}
                                                    viewBoxMax={'29'}
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                />
                                                <Icon
                                                    icon={ICONS.NEW_WINDOW}
                                                    fill="#9c9c9c"
                                                    size={'16'}
                                                    viewBoxMax={'22'}
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    ariaLabel={newTabAriaLabel}
                                                    tabIndex={0}
                                                />
                                            </IconWrapper>
                                            <TileTitle>
                                                {TranslationHelpers.getFormattedMessage(
                                                    'top.page.mydata.title',
                                                )}
                                            </TileTitle>
                                            <TileText>
                                                {TranslationHelpers.getFormattedMessage(
                                                    'top.page.tip.of.mydata.title',
                                                )}
                                            </TileText>
                                        </MyDataLink>
                                    </NoPointsTileWrapper>
                                )}
                            </NoPointsWrapper>
                        )}
                    </RouterBaseWrapper>
                    {RegionHelper.isEU() && (
                        <BuTilesWrapper>
                            <BuHeading>
                                {TranslationHelpers.getFormattedMessage('home.intro')}
                            </BuHeading>
                            <BuContainer>
                                <BuLeft>
                                    {buContentIndexes.map((idx: number, index: number) => {
                                        if (buContent[idx].id !== services.CROP) {
                                            let style = {
                                                background: buContent[idx].backgroundColor,
                                            };
                                            return (
                                                <React.Fragment>
                                                    <HomeTile
                                                        localStyles={leftBuTileStyles}
                                                        key={buContent[idx].id}
                                                    >
                                                        <BuTileLink
                                                            className={`tst-tl${index}`}
                                                            style={style}
                                                            href={buContent[idx].links[0].link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <BuLogoImage
                                                                localStyles={
                                                                    buContent[idx].id ===
                                                                    services.FRANCE
                                                                        ? rakutenFranceLogoStyles
                                                                        : ''
                                                                }
                                                                src={buContent[idx].logo.white}
                                                                alt={buContent[idx].alt}
                                                            />
                                                            <BuTileText
                                                                localStyles={
                                                                    buContent[idx].id ===
                                                                    services.FRANCE
                                                                        ? rakutenFranceStyles
                                                                        : ''
                                                                }
                                                            >
                                                                {buContent[idx].heading}
                                                            </BuTileText>
                                                            <ArrowIcon>
                                                                <Icon
                                                                    icon={ICONS.ARROW_RIGHT}
                                                                    size={'24'}
                                                                />
                                                            </ArrowIcon>
                                                        </BuTileLink>
                                                    </HomeTile>
                                                </React.Fragment>
                                            );
                                        } else return null;
                                    })}
                                </BuLeft>
                                <BuRight>
                                    {buContent.map((bu: Record<string, any>, index: number) => {
                                        if (bu.id === services.CROP) {
                                            let style = { background: bu.backgroundColor };
                                            return (
                                                <HomeTile
                                                    localStyles={rightBuTileStyles}
                                                    key={bu.id}
                                                >
                                                    <BuTileLink
                                                        className={`tst-tl${index}`}
                                                        style={style}
                                                    >
                                                        <BuLogoImage
                                                            src={bu.logo.white}
                                                            alt={bu.alt}
                                                        />
                                                        <BuTileText>{bu.heading}</BuTileText>
                                                        {bu.links.map(
                                                            (record: Record<string, string>) => {
                                                                return (
                                                                    <BuSiteLinks
                                                                        key={record.link}
                                                                        href={record.link}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        <span>
                                                                            {TranslationHelpers.getFormattedMessage(
                                                                                record.name,
                                                                            )}
                                                                        </span>
                                                                        <Icon
                                                                            size="24"
                                                                            icon={ICONS.ARROW_RIGHT}
                                                                        />
                                                                    </BuSiteLinks>
                                                                );
                                                            },
                                                        )}
                                                    </BuTileLink>
                                                </HomeTile>
                                            );
                                        } else return null;
                                    })}
                                </BuRight>
                            </BuContainer>
                        </BuTilesWrapper>
                    )}
                </BaseWrapper>
            </Base>
        );
    }
}
export default injectIntl(TilesDesktop);
